import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing[12]};
`;
